import React from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import LoadingIcon from "../../components/Loaders/LoadingIcon";
import { format } from "date-fns";
import axios from "../../services/axios/backendAxios";

const Referrals = () => {
  const perPage = 10;
  const query = useInfiniteQuery({
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages, lastPageParam) =>
      lastPage.length < perPage ? null : lastPageParam + 1,
    queryKey: [`referral`],
    queryFn: async ({ pageParam }) => {
      let params = {
        skip: pageParam * perPage,
        take: perPage,
      };
      const resp = await axios.get(`referral?${new URLSearchParams(params)}`);
      return resp.data.referrals;
    },
  });
  return (
    <div>
      <h2 className="text-lg font-bold">Recent Referrals</h2>
      {query.isPending ? (
        <LoadingIcon />
      ) : (
        <table className="text-sm w-full">
          <thead>
            <tr>
              <th className="py-2 px-1 text-left">Referred By</th>
              <th className="py-2 px-1 text-left">New Customer</th>
              <th className="py-2 px-1 text-left">Date</th>
            </tr>
          </thead>
          <tbody className="text-gray-600">
            {query.data.pages.map((page) =>
              page.map((r) => (
                <tr key={r._id} className="border-t border-gray-200">
                  <td className="p-1">
                    <a
                      className="underline"
                      href={`https://dashboard.stripe.com/customers/${r.referredByCustomerStripeId}`}
                    >
                      {r.referredByUser.firstName} {r.referredByUser.lastName}
                      <br />
                      {r.referredByCompany.name}
                    </a>
                  </td>
                  <td className="p-1">
                    <a
                      className="underline"
                      href={`https://dashboard.stripe.com/customers/${r.referredCustomerStripeId}`}
                    >
                      View
                    </a>
                  </td>
                  <td className="p-1">
                    {format(new Date(r.createdAt), "MMM d, yyyy")}
                  </td>
                </tr>
              )),
            )}
            {query.hasNextPage ? (
              <tr className="p-1">
                <td
                  colSpan={3}
                  onClick={query.fetchNextPage}
                  className="text-center underline cursor-pointer"
                >
                  Load More
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Referrals;
